import { render, staticRenderFns } from "./WabaSupsisPartnerAppInstalled.vue?vue&type=template&id=6665ba68&scoped=true"
import script from "./WabaSupsisPartnerAppInstalled.vue?vue&type=script&lang=js"
export * from "./WabaSupsisPartnerAppInstalled.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisPartnerAppInstalled.vue?vue&type=style&index=0&id=6665ba68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665ba68",
  null
  
)

export default component.exports